import React from 'react'
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
// import "./Header.scss"

function Header() {
  return (
    <div className='header'>
      <div className='left_header'>
        POS
      </div>
      <div className="rignt_header">
        <NotificationsNoneIcon/>
        <AccountCircleIcon/>

      </div>
    </div>
  )
}

export default Header